import LTR from "@brand-icons/ploom/long-arrow-forward/long-arrow-forward-ltr.svg";
import RTL from "@brand-icons/ploom/long-arrow-forward/long-arrow-forward-rtl.svg";

import { iconFactory } from "../iconFactory";

export const LongArrowForwardIcon = iconFactory("LongArrowForwardIcon", LTR, RTL);
